import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'allCaps'
})
export class AllCapsPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value ? value.toString().toUpperCase() : value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/all-caps.pipe.ts